import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import Insights from "@/pages/Insights";
import Speaking from "@/pages/Speaking";
import Partner from "@/pages/Partner";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminInquiries from "@/pages/AdminInquiries";
import { AdminAuthProvider } from "@/lib/adminAuth";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function NotFound() {
  return (
    <section className="bjc-section" data-testid="not-found">
      <div className="max-w-[800px] mx-auto px-6 text-center">
        <span className="bjc-overline">— 404</span>
        <h1 className="mt-6 font-serif-display text-4xl md:text-6xl text-[var(--bjc-text)]">
          Page not found.
        </h1>
        <p className="mt-6 text-[var(--bjc-text-muted)]">
          The page you were looking for could not be located. Please return to the homepage.
        </p>
        <a href="/" className="mt-10 inline-flex bjc-btn-primary" data-testid="not-found-cta">
          Return Home
        </a>
      </div>
    </section>
  );
}

function PublicLayout() {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <AdminAuthProvider>
          <Routes>
            {/* Admin routes — no public chrome */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/inquiries" element={<AdminInquiries />} />

            {/* Public site */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/speaking" element={<Speaking />} />
              <Route path="/partner" element={<Partner />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </AdminAuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0F0F11",
            border: "1px solid rgba(197,168,128,0.3)",
            color: "#F3F2EE",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
